import React, { Component } from 'react'
import { DataGrid, GridColumn, LinkButton, TextBox, Panel, Messager, DateBox, ComboBox } from 'rc-easyui';
import { API_URL } from '../../../constants';
import { getAccessToken, getCookie } from '../../../helpers/cookieHelper';
import { Link, Redirect } from "react-router-dom";



const axios = require("axios");
export default class ViewTicketDetail extends Component {



  constructor(props) {
    super(props)

    this.state = {
      id:'',
      view:false,
      pageArray: [],
      StatusList: [],
      pageOptions: {},
      searchparam: {
        projectName: '',
        expectedCompletionDateAd: '',
        userName: '',
        priority: "",
        status: "",
        enabled: true,
        version: "",


      },
      isLoading: false,
      pageOptions: {
        pageOptions: {
          layout: [
            "list",
            "sep",
            "first",
            "prev",
            "next",
            "last",
            "sep",
            "refresh",
            "sep",
            "manual",
            "info",
          ],
        },
      },
    }
  }






  componentDidMount = async () => {
    const date = new Date();
    let fullYear = date.getFullYear();
    let fullMonth = date.getMonth()
    let fullDay = date.getDate()
    let formattedDate = fullYear + '-' + (fullMonth + 1) + '-' + fullDay
    const today = formattedDate;

    this.setState({
      view:false,
      pageOptions: {
        loading: true,
        pageOptions: {
          pageNumber: 1,
          pageSize: 10,
          // pagePosition: 'bottom',
          // pageList: [10, 20, 30, 40, 50, 60, 70, 80],
          layout: [
            'list',
            'sep',
            'first',
            'prev',
            'next',
            'last',
            'sep',
            'refresh',
            'sep',
            'manual',
            'info',
          ],
        },
      },

    },
      () => {
        this.getPageData()



      })
  }


  getPageData = async () => {
    const { pageNumber, pageSize } = this.state.pageOptions.pageOptions;
    const { projectName, expectedCompletionDateAd, status, userName, priority, version, enabled } = this.state.searchparam;

    var access_token = getCookie("access_token");
    var token_type = getCookie("token_type");
    let headerConfig = {
      headers: {
        authorization: token_type + " " + access_token,
        "Content-Type": "application/json",
      }
    }
    let enable = true;
    if (enabled) {
      enable = 1
    } else {
      enable = 0
    }
    var url = `${API_URL}api/getticketwithpagination?username=${userName}&priority=${priority}&expectedcompletiondatead=${expectedCompletionDateAd}&status=${status}&projectname=${projectName}&version=${version}&enabled=${enable}&rows=${pageSize}&page=${pageNumber}`;

    this.setState({
      pageOptions: {
        pageOptions: { ...this.state.pageOptions.pageOptions },
        loading: true,
      },
    });
    if (access_token != null) {
      axios.get(url, headerConfig)
        .then((response) => {
          if (response.status === 200) {
            let pageArr = response.data.rows;
            let total = response.data.total;
            this.setState({
              pageArray: pageArr,
              pageOptions: {
                pageOptions: {
                  pageSize: Math.min(10, 50, 30, 100, total),
                  total: total,
                  pageList: [10, 50, 30, 100, total].sort(
                    function (a, b) {
                      return a - b;
                    }),
                  total: total,
                  ...this.state.pageOptions.pageOptions,
                },
                loading: false,
              },
            });
          } else {
            this.setState({
              pageOptions: {
                pageOptions: { ...this.state.pageOptions.pageOptions },
                loading: false,
              }
            })
          }
        })
        .catch((error) => {
          this.setState({
            pageOptions: {
              pageOptions: { ...this.state.pageOptions.pageOptions },
              loading: false,
            },
          });
        });
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.getPageData();
      }
    }
  }


  searchFieldOnChange = (name, e) => {
    let searchparam = Object.assign({}, this.state.searchparam)

    searchparam[name] = e

    this.setState({ searchparam: searchparam })
  }


  onPageChange = (event) => {

    this.setState(
      {
        pageOptions: {
          pageOptions: { ...this.state.pageOptions.pageOptions, ...event },
          loading: true,
        },
      },
      function () {
        this.getPageData();
      }
    );

  }

  redirect=(id)=>{
    this.setState({view:true,id:`/update-detail-page/?id=${id}`})
    
  }


  render() {
    const { permissions, userList } = this.props;
    const searchparam = this.state.searchparam;
    const isLoading = this.state.isLoading;
    const pageArray = this.state.pageArray;

    if(this.state.view){
      return <Redirect to={this.state.id}/>
    }else{
      return (
        <div>
  
          <Panel
            title='Ticket Detail Data'
            bodyStyle={{ padding: 0 }}
            style={{ height: 640, width: '100%' }}>
            <Messager
              ref={(ref) => (this.messager = ref)}
              showHeader={false}
              borderType='none'
              content={({ title, msg, buttons, reload }) => (
                <div className='alert-content'>
                  <h3>{title}</h3>
                  <div
                    style={{ marginBottom: 5 }}
                    dangerouslySetInnerHTML={{ __html: msg }}
                  ></div>
                  <div className='m-buttons'>
                    {buttons.map((button, index) => (
                      <LinkButton
                        key={index}
                        text={button.text}
                        onClick={() => {
                          this.messager.close(button);
                          if (reload) {
                            window.location.reload();
                          }
                        }}
                      />
                    ))}
                  </div>
                </div>
              )}
            />
            <div
              className='loadingmodel'
              style={{ display: isLoading ? "block" : "none" }}
            ></div>
            <DataGrid
              data={pageArray}
              style={{ height: 610, width: '100%' }}
              selectionMode='single'
              {...this.state.pageOptions}
              pagination
              {...this.props.selectedRow}
              onSelectionChange={(selection) =>
                this.redirect(selection.id)
              }
              onPageChange={this.onPageChange}
  
              toolbar={({ editingItem }) => (
                <div style={{ padding: 4 }}>
  
                  <div className='row'>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Project</b>&nbsp;
                    <ComboBox
                      style={{ width: 150, marginRight: 10 }}
                      data={this.props.projectList}
                      valueField='id'
                      textField='projectName'
                      value={searchparam.projectName}
                      onChange={(e) => this.searchFieldOnChange("projectName", e)}
                    ></ComboBox>
                    &nbsp;
                    <b>Username</b>&nbsp;
                    <ComboBox
                      data={userList}
                      value={searchparam.userName}
                      valueField="id"
                      textField="username"
                      style={{ width: 150 }}
                      onChange={(e) => this.searchFieldOnChange("userName", e)} />
                    &nbsp;
                    <b>Ticket Status</b>&nbsp;
                    <ComboBox
                      data={this.props.StatusList}
                      style={{ width: 150 }}
                      valueField='id'
                      textField='status'
                      value={searchparam.status}
                      editable={false}
                      onChange={(e) => this.searchFieldOnChange("status", e)}
                    ></ComboBox>
                  </div>
                  <div className='row' style={{ marginTop: 5 }}>
                    &nbsp;    &nbsp;&nbsp;&nbsp;<b>Status  </b>&nbsp;
                    <ComboBox
                      style={{ width: 150 }}
                      data={this.props.enableStatus}
                      value={searchparam.enabled}
                      editable={false}
                      onChange={(e) => this.searchFieldOnChange("enabled", e)}
                    ></ComboBox>
                    &nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Priority</b>&nbsp;
                    <ComboBox
                      style={{ width: 150 }}
                      data={this.props.priorityList}
                      valueField='id'
                      textField='priority'
                      value={searchparam.priority}
                      onChange={(e) => this.searchFieldOnChange("priority", e)}
                    ></ComboBox>
                    &nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Date</b>&nbsp;
                    <DateBox
                      format="yyyy-MM-dd"
                      value={searchparam.expectedCompletionDateAd}
                      style={{ width: 150 }}
                      onChange={(e) => this.searchFieldOnChange("expectedCompletionDateAd", e)}
                    ></DateBox>
                    <LinkButton
                      iconCls="icon-search"
                      plain
                      onClick={this.getPageData}
  
                    >
                      Search
                    </LinkButton>
                  </div>
  
                </div>
  
              )}>
  
              <GridColumn
                width={50}
                field='id'
                title='Id'
                align='center'
              />
              <GridColumn width={150} field="projectName" title="Project Name"></GridColumn>
              <GridColumn width={150} field="summary" title="Summary"></GridColumn>
              <GridColumn width={150} field="assigneeName" title="Assignee"></GridColumn>
              <GridColumn width={150} field="priority" title="Priority"></GridColumn>
              <GridColumn width={150} field="ticketType" title="Ticket Type"></GridColumn>
              <GridColumn width={150} field="status" title="Status"></GridColumn>
              {/* <GridColumn width={150} field="createdBy" title="Created By"></GridColumn> */}
  
              {/* <GridColumn
                field="act"
                title="Actions"
                align="center"
                width={170}
                render={({ row }) => (
                  <div>
                    {permissions.includes(
                      "ticket-edit"
                    ) ? (
  
                      <React.Fragment>
                        <span style={{ paddingTop: 5 }}>||</span>
                        <Link className="btn btn-link btn-sm" to={"/update-detail-page/?id=" + row.id}>
  
                          View
  
                        </Link>
                      </React.Fragment>) : null}
  
  
  
                  </div>
                )}
              /> */}
  
  
  
            </DataGrid>
          </Panel>
  
  
  
  
        </div>
      )
    }


  }
}
